/**
 * The email signup box, standard look (Dana's footer box): the email field and Subscribe in one row, the
 * consent line with Privacy under them, and the thank-you line in their place after a signup. Draws the
 * behavior half; holds no rule.
 */
import type { FormEvent } from 'react';

import { partsOf, pieceRoot } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import type { EmailSignupRuntime } from './useEmailSignup';
import css from './EmailSignup.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function EmailSignupView(runtime: EmailSignupRuntime) {
  const { state, actions, options } = runtime;

  if (state.status === 'done') {
    return (
      <p className={css.done} role="status" {...pieceRoot(contract)} {...part('done')}>
        {options.done}
      </p>
    );
  }

  const sending = state.status === 'sending';
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    actions.submit(String(new FormData(e.currentTarget).get('email') ?? ''));
  };
  return (
    <form className={css.piece} noValidate onSubmit={onSubmit} {...pieceRoot(contract)} {...part('form')}>
      <div className={css.row}>
        <input
          className={css.email}
          type="email"
          name="email"
          autoComplete="email"
          placeholder={options.placeholder ?? undefined}
          aria-label={options.placeholder ?? 'Email'}
          aria-invalid={state.error ? true : undefined}
          maxLength={254}
          onFocus={runtime.prepare}
          {...part('email')}
        />
        <button type="submit" className={`${shared.btn} ${shared.btnOutline} ${css.submit}`} disabled={sending} {...part('submit', sending && 'disabled')}>
          {sending ? 'Subscribing…' : options.buttonLabel}
        </button>
      </div>
      {/* A person never fills it; it is off-screen and out of the tab order. */}
      <input ref={runtime.trapRef} className={css.trap} name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      {state.error && !sending && (
        <p className={css.error} role="alert" {...part('error')}>
          {state.error}
        </p>
      )}
      <p className={css.consent} {...part('consent')}>
        {runtime.consent}{' '}
        <a href={runtime.privacyHref} target="_blank" rel="noopener" {...part('privacy')}>
          Privacy
        </a>
      </p>
    </form>
  );
}
